import Vue from 'vue';
import Router from 'vue-router';

import ShopListPage from 'vues/elearning-application/components/pages/ShopListPage';
import AboutPage from 'vues/elearning-application/components/pages/AboutPage';
import TermsPage from 'vues/elearning-application/components/pages/TermsPage';
import ApplicationFormPage from 'vues/elearning-application/components/pages/ApplicationFormPage';
import ConsentPage from 'vues/elearning-application/components/pages/ConsentPage';
import MedicalCheckPage from 'vues/elearning-application/components/pages/MedicalCheckPage';
import CourseListPage from 'vues/elearning-application/components/pages/CourseListPage';
import PaymentPage from 'vues/elearning-application/components/pages/PaymentPage';
import CompletedPage from 'vues/elearning-application/components/pages/CompletedPage';
import store from 'store/';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      component: ShopListPage,
      beforeEnter: async (to, from, next) => {
        if (from.path === '/') {
          // ショップを取得する
          store.commit('shop/reset');
          await store.dispatch('shop/getShopsForELearningApplication');

          // コースを取得する
          store.commit('course/reset');
          await store.dispatch('course/getCoursesForElearningApplication');

          // メディカルチェックの質問を取得する
          store.commit('medicalCheck/reset');
          await store.dispatch('medicalCheck/getQuestions');

          if (process.env.RAILS_ENV === 'development') {
            // テスト用データをセットする
            store.commit('elearningApplication/resetForTest');
          } else {
            // 入力項目をクリアする
            store.commit('elearningApplication/reset');
          }
        }
        to.params.correctAccess = true; // /aboutで正しい遷移かを判定するパラメータ
        next();
      },
    },
    {
      path: '/about',
      component: AboutPage,
      beforeEnter: (to, from, next) => {
        //console.log('from.params.correctAccess: ' + from.params.correctAccess);
        if ((from.path === '/' || from.path === '/terms') && from.params.correctAccess) {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/terms',
      component: TermsPage,
      beforeEnter: (to, from, next) => {
        if (from.path === '/about' || from.path === '/course-list') {
          to.params.correctAccess = true; // /aboutで正しい遷移かを判定するパラメータ
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/course-list',
      component: CourseListPage,
      beforeEnter: (to, from, next) => {
        if (from.path === '/terms' || from.path === '/application-form') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/application-form',
      component: ApplicationFormPage,
      beforeEnter: (to, from, next) => {
        if (from.path === '/course-list' || from.path === '/consent') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/consent',
      component: ConsentPage,
      beforeEnter: (to, from, next) => {
        if (from.path === '/application-form' || from.path === '/medical-check') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/medical-check',
      component: MedicalCheckPage,
      beforeEnter: (to, from, next) => {
        if (from.path === '/consent') {
          next();
        } else if (from.path === '/payment') {
          let course = store.getters['elearningApplication/course'];
          if (course === null) next('/');
          if (!course.name) next('/');
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/payment',
      component: PaymentPage,
      beforeEnter: (to, from, next) => {
        if (from.path === '/medical-check') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/completed',
      component: CompletedPage,
      beforeEnter: (to, from, next) => {
        if (from.path === '/payment') {
          next();
        } else {
          next('/');
        }
      },
    },
  ],
  /**
   * 参考：https://codekneading.com/blog/2019/11/vue-router-scroll-position.html#%E6%A6%82%E8%A6%81
   * @param {} to
   * @param {*} from
   * @param {*} savedPosition
   * @returns
   */
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // return new Promise((resolve, reject) => {
      //   setTimeOut(() => {
      //     resolve(savedPosition);
      //   });
      // });
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
